<template>
  <div class="wai">
    <div class="juese">
      <div class="curd">
        <div class="sou">
          <span style="margin-right: 10px;">角色名称</span>
          <el-input v-model="content" style="width: 240px;margin-right: 20px;" placeholder="角色名称（模糊搜索）" clearable />
          <el-button round @click="getlist()">查询</el-button>
        </div>
      </div>
      <div class="zhu">
        <el-collapse v-model="active">
          <el-collapse-item v-for="(item,index) in list" :key="index" :title="item.name" :name="item.id">
            <el-table :data="item.rolelist" style="width: 100%"><!-- :show-header="false" -->
              <el-table-column prop="id" label="id" />
              <el-table-column prop="name" label="角色名称" />
              <el-table-column prop="description" label="描述" />
              <el-table-column label="操作">
                <template #default="{ row }">
                  <el-button type="primary" @click="xuanzhong(row,item.id)" size="small">分配</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="ziyuan">
      <div style="margin-bottom: 20px;display: flex;justify-content: space-between;">
        <h4>当前角色所属部门可用资源</h4>
        <el-button v-if="keyong" plain round @click="rolefenpei()">确认分配</el-button>
      </div>
      <div v-if="keyong">
        <div v-for="(item,index) in keyong" :key="index" style="padding-left: 30px;">
          {{item.name}}
          <el-checkbox-group v-model="selectedIds">
            <div v-for="(ite,inde) in item.list" :key="inde" style="padding-left: 20px;">
              <el-checkbox :label="ite.id">
                {{ ite.name }}
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {
    ElMessage
  } from 'element-plus';
  import {
    onMounted,
    reactive,
    ref
  } from 'vue';
  import {
    addrole,
    delrole,
    getrolehaveziyuan,
    getrolelist,
    getroleuse,
    updrole,
    uproleziyuan
  } from '@/api/api'
  onMounted(() => {
    getlist()
  })
  const dialog = ref(false)
  const curdtype = ref(1)

  //折叠面板的
  const active = ref([])
  //模糊搜索的
  const content = ref()

  //部门id
  const did = ref()
  //角色id
  const rid = ref()

  const list = ref()
  const getlist = async () => {
    const data = {
      content: content.value
    }
    const res = await getrolelist(data)
    if (res.code == 200) {
      list.value = res.data.list
    } else {
      ElMessage.error(res.message)
    }
  }
  const keyong = ref()
  //获取部门可分配资源
  const getroleuseziyuan = async () => {
    const data = {
      department_id: did.value
    }
    const res = await getroleuse(data)
    if (res.code == 200) {
      keyong.value = res.data.list
    }
  }
  //获取角色已有资源
  const getrolehave = async () => {
    const data = {
      role_id: rid.value
    }
    const res = await getrolehaveziyuan(data)
    if (res.code == 200) {
      selectedIds.value = res.data.list
    }
  }
  //选中角色
  const xuanzhong = (row, depid) => {
    did.value = depid
    rid.value = row.id
    getrolehave()
    getroleuseziyuan()
  }

  // 存储已勾选的节点
  const selectedIds = ref([])
  //分配资源
  const rolefenpei = async () => {
    const data = {
      role_id: rid.value,
      list: selectedIds.value
    }
    const res = await uproleziyuan(data)
    if (res.code == 200) {
      ElMessage.success("资源分配成功")
      selectedIds.value = []
      keyong.value = null
    }
  }
</script>

<style lang="scss" scoped>
  .wai {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    display: flex;
    justify-content: center;

    .juese {
      width: 50%;

      .curd {
        height: 50px;
        width: 100%;
        display: flex;
        justify-content: space-between;
      }

      .zhu {
        width: 100%;
        height: calc(100% - 45px - 50px);
        overflow-y: auto;
        border-radius: 10px;

        .biao {
          width: 100%;
          border-collapse: collapse;
          border-spacing: 0;

          .tou {
            font-weight: bolder;
            color: #000;
            height: 40px;
            background-color: #dddddd;
          }

          .shen {
            height: 40px;
            color: #000;
            text-align: center;
            font-size: 16px;
          }

          .shen:nth-child(odd) {
            background-color: #F5F7FA;
          }
        }
      }
    }

    .ziyuan {
      width: 50%;
      padding: 0 20px;
    }
  }

  .adddig {
    .group {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      padding: 10px 0px;

      .lab {
        padding-left: 20px;
        width: 130px;
      }
    }
  }
</style>
